import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { prefixPhoneNumberWithPlus } from "@utils/phoneNumberPrefix";
import { showSuccessNotification } from "@utils/showNotification";

import { patientQKeys } from "@hooks/queries/patient/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Patient } from "@customTypes/patient";

export const useCreatePatient = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (patient: Patient) => {
      return api.post(`patient/create`, {
        first_name: patient.firstName,
        middle: patient.middleName,
        surname: patient.surname,
        dob: (patient.dob as string).trim(),
        gender: patient.gender,
        email: patient.email,
        phone_number: prefixPhoneNumberWithPlus(patient.phoneNumber),
        alternate_phone: prefixPhoneNumberWithPlus(patient.altPhoneNumber),
        country: patient.country,
        state: patient.state,
        city: patient.city,
        emergency_name: patient.emergencyContactName,
        emergency_contact: prefixPhoneNumberWithPlus(
          patient.emergencyContactPhoneNumber
        ),
        emergency_relationship: patient.emergencyContactRelationship,
        emergency_country: patient.emergencyContactCountry,
        height: patient.height,
        weight: patient.weight,
        blood_type: patient.bloodType,
        donor:
          patient.bloodDonor?.toLocaleLowerCase().at(0) === "y" ? true : false,
        Job: patient.occupation,
        drinking_habits: patient.drinkingHabits,
        Exercise: patient.exerciseFrequency,
        Diet: patient.diet,
        Smoke: patient.smokingHabits,
        BillingCard: patient.insuranceType,
        Policy_Number: patient.insurancePolicyNumber,
        Provider: patient.insuranceProvider,
        Expiry: patient.insuranceExpiry,
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "create-patient-success",
      });
      queryClient.invalidateQueries({
        queryKey: patientQKeys.all(),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Patient]", res);

      handleErrors(res, "mutation");
    },
  });
};
